import { render, staticRenderFns } from "./tagsHit.vue?vue&type=template&id=b2fde96c&scoped=true&"
import script from "./tagsHit.vue?vue&type=script&lang=js&"
export * from "./tagsHit.vue?vue&type=script&lang=js&"
import style0 from "./tagsHit.vue?vue&type=style&index=0&id=b2fde96c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2fde96c",
  null
  
)

export default component.exports